// Values are class names from ./styles.scss
export enum LoadingSpinnerTheme {
  Dark = 'dark',
  Light = 'light',
}

// Values are class names from ./styles.scss
export enum LoadingSpinnerSize {
  Minute = 'minute',
  Tiny = 'tiny',
  Small = 'small',
  Medium = 'medium',
}
